import { useCallback } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { LEGACY_CONTENT_MODEL_SAVED_VIEW_PROPERTY_NAME } from '../constants/properties';
import useTableColumnUserSettingsKeys from './useTableColumnUserSettingsKeys';
import { USER_SETTINGS_QUERY_NAME, UserSettingsQuery } from './useCmsUserSettings';
export const UpdateTableColumnsMutation = registerMutation({
  fieldName: 'updateTableColumns',
  args: ['updatedColumns', 'columnUserSettingsKey', 'legacyColumnKey'],
  fetcher: ({
    updatedColumns,
    columnUserSettingsKey,
    legacyColumnKey
  }) => {
    return http.patch('cms-user-settings', {
      data: Object.assign({
        [columnUserSettingsKey]: updatedColumns
      }, legacyColumnKey ? {
        [legacyColumnKey]: updatedColumns.map(column => LEGACY_CONTENT_MODEL_SAVED_VIEW_PROPERTY_NAME[column] || column)
      } : {})
    });
  }
});
const useUpdateTableColumns = () => {
  const {
    columnUserSettingsKey,
    legacyColumnKey
  } = useTableColumnUserSettingsKeys();
  const [mutate, result] = useMutation(UpdateTableColumnsMutation);
  const mutateCallback = useCallback(updatedColumns => mutate({
    variables: {
      updatedColumns,
      legacyColumnKey,
      columnUserSettingsKey
    },
    update(cache, newData) {
      var _newData$data;
      if ((_newData$data = newData.data) !== null && _newData$data !== void 0 && _newData$data.updateTableColumns) {
        var _newData$data2;
        cache.writeQuery({
          query: UserSettingsQuery,
          data: {
            [USER_SETTINGS_QUERY_NAME]: (_newData$data2 = newData.data) === null || _newData$data2 === void 0 ? void 0 : _newData$data2.updateTableColumns
          }
        });
      }
    }
  }), [legacyColumnKey, columnUserSettingsKey, mutate]);
  return [mutateCallback, result];
};
export default useUpdateTableColumns;